import { damp } from "@studiometa/js-toolkit/utils";
import { Base } from "@studiometa/js-toolkit";
class LargeText extends Base {
  constructor() {
    super(...arguments);
    this.x = 0;
    this.transform = {
      x: 0
    };
    this.width = 0;
  }
  mounted() {
    this.width = this.$refs.target.clientWidth;
  }
  resized() {
    this.width = this.$refs.target.clientWidth;
  }
  ticked() {
    this.x -= 1;
    this.transform.x = damp(this.x, this.transform.x, 0.5);
    if (this.x <= this.width * -1) {
      this.x = 0;
      this.transform.x += this.width;
    } else if (this.$options.sensitivity < 0 && this.x >= this.width) {
      this.x = 0;
      this.transform.x -= this.width;
    }
    this.$refs.target.style.transform = `translate(${this.transform.x}px, 0)`;
  }
}
LargeText.config = {
  name: "LargeText",
  refs: ["target"]
};
export {
  LargeText as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
